import React from "react";
import { Dropdown } from "react-bootstrap";
import CheckIcon from "../../../icons/check.icon.jsx";
import styles from "./FiltersDropdown.module.scss";

const FiltersDropdown = ({ tableFilters = [], addFilter, selectedFilters = [], setSelectedFilters }) => {
  const hasActiveFilters = selectedFilters?.length > 0;

  const isFilterSelected = (filter) => {
    if (!selectedFilters || selectedFilters.length === 0) return false;
    const filterKey = filter.filterKey;
    return selectedFilters.some((selectedFilter) => selectedFilter.key === filterKey);
  };

  const handleFilterToggle = (filter) => {
    if (!setSelectedFilters) {
      // Fallback to addFilter if setSelectedFilters is not provided
      if (addFilter) {
        addFilter(filter);
      }
      return;
    }

    const filterKey = filter.filterKey;
    const isSelected = isFilterSelected(filter);

    if (isSelected) {
      // Remove filter if already selected
      setSelectedFilters((prevFilters) =>
        prevFilters.filter((selectedFilter) => selectedFilter.key !== filterKey)
      );
    } else {
      // Add filter if not selected
      if (addFilter) {
        addFilter(filter);
      }
    }
  };

  return (
    <Dropdown className={styles.dropdown}>
      <Dropdown.Toggle
        as="div"
        className={hasActiveFilters ? styles.toolbarButtonActive : styles.toolbarButton}
        aria-label="Filter"
      >
        <div className={styles.toolbarButtonInner}>
          <img
            src="/images/filter-icon.svg"
            alt=""
            className={styles.toolbarButtonIcon}
            width={16}
            height={16}
          />
        </div>
      </Dropdown.Toggle>
      <Dropdown.Menu className={styles.menu}>
        <div className={styles.dropdownContent} role="group" aria-labelledby="filters-heading">
          <div className={styles.header}>
            <h2 id="filters-heading" className={styles.headerTitle}>
              Filters
            </h2>
          </div>

          {tableFilters?.length > 0 ? (
            tableFilters.map((filter) => {
              const filterId = `filter-${filter.filterKey || filter.text}`;
              const isSelected = isFilterSelected(filter);
              
              return (
                <label
                  key={filter.filterKey || filter.text}
                  className={styles.filterLabel}
                  htmlFor={filterId}
                >
                  <input
                    type="checkbox"
                    id={filterId}
                    checked={isSelected}
                    onChange={(e) => {
                      e.stopPropagation();
                      handleFilterToggle(filter);
                    }}
                    onClick={(e) => {
                      e.stopPropagation();
                    }}
                    className={styles.srOnly}
                    aria-label={filter.filterTitle || filter.text}
                  />
                  {isSelected ? (
                    <div className={styles.checkboxChecked}>
                      <CheckIcon className={styles.checkIcon} />
                    </div>
                  ) : (
                    <div className={styles.checkboxUnchecked} />
                  )}

                  <span className={styles.filterText}>
                    {filter.filterTitle || filter.text}
                  </span>
                </label>
              );
            })
          ) : (
            <div className={styles.noFilters}>
              <span className={styles.noFiltersText}>No filters available</span>
            </div>
          )}
        </div>
      </Dropdown.Menu>
    </Dropdown>
  );
};

export default FiltersDropdown;

